import { render, staticRenderFns } from "./AdminUpdatedCases.vue?vue&type=template&id=63a180b7"
import script from "./AdminUpdatedCases.vue?vue&type=script&lang=js"
export * from "./AdminUpdatedCases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports